import { isMobile } from "react-device-detect";
import axios from "./axiosInstance";

export const paymentRequest = async (
  isProduct = true,
  payment_method = "card", // card or bank
  product_id = "",
  agent_code = "",
  buyer_name = "",
  payment_content = "",
  amount = "",
  receipt_requested = false
) => {
  try {
    let params = {
      payment_method,
      product_id,
      redirect_url: process.env.REACT_APP_URL + "/product_payment_result",
      agent_code,
      receipt_requested,
    };

    if (isProduct) {
      params = {
        ...params,
        is_mobile: isMobile,
      };
    } else {
      params = {
        ...params,
        buyer_name,
        payment_content,
        amount,
      };
    }

    const res = await axios.post("/api/payment/initiate", params);

    return res.data;
  } catch (err) {
    console.error(err);

    return {};
  }
};

export const paymentHistory = async (page = 1, pageSize = 10) => {
  try {
    const res = await axios.get(
      "/api/payment-history?pageSize=" + pageSize + "&page=" + page
    );

    return res.data;
  } catch (err) {
    console.error(err);

    return {};
  }
};

export const couponMessageResend = async (coupon_id) => {
  try {
    const res = await axios.post("/api/coupons/resend", {
      coupon_id,
    });

    return res.data;
  } catch (err) {
    console.error(err);

    return {};
  }
};

export const subscriptionRegister = async (
  product_id = "",
  amount = "",
  payment_day = "",
  cardNumb = "",
  expiryDate = "",
  password2 = "",
  userInfo = "",
  buyer_name = "",
  payment_content = "",
  agent_code = "",
  receipt_requested = false
) => {
  try {
    let params = {
      product_id,
      amount,
      payment_day,
      card_info: {
        cardNumb,
        expiryDate,
        password2,
        userInfo,
      },
      buyer_name,
      payment_content,
      agent_code,
      receipt_requested,
    };

    const res = await axios.post("/api/subscription/register", params);

    return res.data;
  } catch (err) {
    console.error(err);

    return {};
  }
};

export const donationList = async (page = 1, pageSize = 10) => {
  try {
    const res = await axios.get(
      "/api/donate-history?pageSize=" + pageSize + "&page=" + page
    );

    return res.data;
  } catch (err) {
    console.error(err);

    return {};
  }
};

export const subscriptionList = async () => {
  try {
    // active 활성, canceled 해지됨, suspended 일시정지
    const res = await axios.get("/api/subscription/list?status=active");

    return res.data;
  } catch (err) {
    console.error(err);

    return {};
  }
};

export const subscriptionCancel = async (
  subscription_id,
  cancel_reason = ""
) => {
  try {
    const params = { cancel_reason };

    const res = await axios.post(
      `/api/subscription/cancel/${subscription_id}`,
      params
    );

    return res.data;
  } catch (err) {
    console.error(err);

    return {};
  }
};
